/**
 * Show messages
 */
var autoCloseMessage;

function showMessage(messageHtml) {
	clearTimeout(autoCloseMessage);

	const messageContainer = document.getElementById('messages-container');
	messageContainer.classList.add('hidden-message-item');

	messageContainer.innerHTML = messageHtml;

	setTimeout(() => {
		messageContainer.classList.remove('hidden-message-item');
	}, 100);

	/**
	 * Auto close after 5 seconds
	 */
	autoCloseMessage = setTimeout(() => {
		messageContainer.classList.add('hidden-message-item');
	}, 5000);
}

/**
 * Messages component
 */
class MessageItem extends HTMLElement {
	constructor() {
		super();

		this._closeButton = this.querySelector('.close-message');
		this._onClose = this.closeMessage.bind(this);
		this._closeButton.addEventListener('click', this._onClose);
	}

	disconnectedCallback() {
		this._closeButton?.removeEventListener('click', this._onClose);
	}

	closeMessage() {
		const messagesContainer = this.closest('.messages-container');
		messagesContainer.classList.add('hidden-message-item');
	}
}

customElements.define('message-item', MessageItem);

/**
 * Modal component
 */

class ModalComponent extends HTMLElement {
	constructor() {
		super();

		const currentModalId = this.getAttribute('id');
		this._btnOpenElements = document.querySelectorAll('a[data-modal-target="' + currentModalId + '"]');
		this._closeModalButtons = this.querySelectorAll('[data-close="modal"]');
		this._dontShowButton = this.querySelector('dont-show');
		this._modalHeader = this.querySelector('modal-header');

		this._onShowModal = this.showModal.bind(this);
		this._onKeyDown = this.keyDown.bind(this);

		if (this._modalHeader) this._modalHeader.addEventListener('touchmove', this.closeModal);
		this.addEventListener('click', this.closeModalComponent);
		this.addEventListener('keydown', this._onKeyDown);

		this._btnOpenElements.forEach((element) => {
			element.addEventListener('click', this._onShowModal);
		});

		if (this._dontShowButton) {
			this._dontShowButton.addEventListener('click', this.dontShowModalAgain);
		}

		if (sessionStorage.getItem('modal-dont-show-' + currentModalId) === 'false' || sessionStorage.getItem('modal-dont-show-' + currentModalId) === null) {
			if (this.getAttribute('data-auto-open') == 'true') {
				let timeDelay = 0;
				const autoOpenModal = this;

				if (autoOpenModal.getAttribute('data-time-delay')) {
					timeDelay = autoOpenModal.getAttribute('data-time-delay') * 1000;
				}

				setTimeout(function () {
					autoOpenModal.classList.add('show');
					document.getElementsByTagName('html')[0].classList.add('open-modal');
				}, timeDelay);
			}
		}

		this._closeModalButtons.forEach((element) => {
			element.addEventListener('click', this.closeModal);
		});
	}

	disconnectedCallback() {
		this._modalHeader?.removeEventListener('touchmove', this.closeModal);
		this.removeEventListener('click', this.closeModalComponent);
		this.removeEventListener('keydown', this._onKeyDown);
		this._btnOpenElements?.forEach((element) => {
			element.removeEventListener('click', this._onShowModal);
		});
		this._dontShowButton?.removeEventListener('click', this.dontShowModalAgain);
		this._closeModalButtons?.forEach((element) => {
			element.removeEventListener('click', this.closeModal);
		});
	}

	showModal(e) {
		e.preventDefault();

		const modalId = this.getAttribute('id');
		const btnOpenModal = document.querySelector('[data-modal-target="' + modalId + '"]');

		if (btnOpenModal.classList.contains('active')) {
			btnOpenModal.classList.remove('active');
			btnOpenModal.setAttribute('aria-expanded', false);
			document.getElementsByTagName('html')[0].classList.remove('open-modal');
			this.classList.remove('show');

			setTimeout(() => {
				document.getElementById(modalId).focus();
			}, 300);

			return;
		} else {
			btnOpenModal.classList.add('active');
			btnOpenModal.setAttribute('aria-expanded', true);
			document.getElementsByTagName('html')[0].classList.add('open-modal');
			this.classList.add('show');

			setTimeout(() => {
				document.getElementById(modalId).focus();
			}, 300);

			this.scrollTop = 0;

			return;
		}
	}

	keyDown(e) {
		if (e.keyCode === 27) {
			this.closeModal();
		}

		if (e.keyCode === 9) {
			const currentModal = this;

			setTimeout(() => {
				const focusItem = document.activeElement;

				if (!focusItem.closest('modal-component') || focusItem.tagName == 'BODY') {
					currentModal.querySelector('[tabindex]').focus();
				}
			}, 200);
		}
	}

	closeModal() {
		const closeButton = this;

		const currentModalId = this.closest('modal-component').getAttribute('id');
		const btnDontShow = this.closest('modal-component').querySelector('dont-show');

		if (btnDontShow) {
			if (btnDontShow.classList.contains('active')) {
				sessionStorage.setItem('modal-dont-show-' + currentModalId, 'true');
			} else {
				sessionStorage.setItem('modal-dont-show-' + currentModalId, 'false');
			}
		}

		this.closest('modal-component').classList.remove('show');

		const buttonModal = document.querySelectorAll('[data-modal-target="' + currentModalId + '"]');

		if (buttonModal) {
			buttonModal.forEach((buttonTarget) => {
				buttonTarget.classList.remove('active');
				buttonTarget.setAttribute('aria-expanded', false);
			});
		}

		setTimeout(function () {
			const modalCount = document.querySelectorAll('modal-component.show').length;

			if (modalCount < 1) {
				document.getElementsByTagName('html')[0].classList.remove('open-modal');
			}
		}, 200);

		setTimeout(function () {
			if (closeButton.closest('modal-component').classList.contains('quickview-modal')) {
				if (document.getElementById(currentModalId)) {
					document.getElementById(currentModalId).remove();
				}
			}

			if (closeButton.closest('modal-component').classList.contains('product-live__modal')) {
				closeButton.closest('modal-component').remove();
			}
		}, 400);
	}

	closeModalComponent(e) {
		if (e.target !== this) {
			return;
		} else {
			this.closeModal();
		}
	}

	dontShowModalAgain() {
		this.classList.toggle('active');
	}
}

customElements.define('modal-component', ModalComponent);

class OpenModalComponent extends HTMLElement {
	constructor() {
		super();

		this._onKeyPress = this.keyPress.bind(this);
		this.addEventListener('click', this.openModal);
		this.addEventListener('keypress', this._onKeyPress);
	}

	disconnectedCallback() {
		this.removeEventListener('click', this.openModal);
		this.removeEventListener('keypress', this._onKeyPress);
	}

	keyPress(e) {
		if (e.key === 'Enter') {
			this.openModal(e);
		}
	}

	openModal(e) {
		e.preventDefault();

		const modalId = this.getAttribute('data-modal-target');
		const modalComponent = document.getElementById(modalId);

		//const btnOpenModal = this;

		if (this.classList.contains('active')) {
			this.classList.remove('active');

			this.setAttribute('aria-expanded', false);

			document.getElementsByTagName('html')[0].classList.remove('open-modal');
			modalComponent.classList.remove('show');

			setTimeout(() => {
				modalComponent.focus();
			}, 300);

			return;
		} else {
			this.classList.add('active');

			this.setAttribute('aria-expanded', true);

			document.getElementsByTagName('html')[0].classList.add('open-modal');
			modalComponent.classList.add('show');

			setTimeout(() => {
				// Focus a search/autofocus field inside the modal if it has one (e.g. the
				// mobile search popup); otherwise focus the modal container as before.
				const autofocusEl = modalComponent.querySelector('[autofocus], input[type="search"]:not([type="hidden"])');
				(autofocusEl || modalComponent).focus();
			}, 300);

			return;
		}
	}
}

customElements.define('open-modal', OpenModalComponent);

/**
 * Init swiper slider
 */
class SwiperSliderComponent extends HTMLElement {
	constructor() {
		super();

		const swiper = this.querySelector('.swiper');
		const optionString = this.querySelector('slider-options').innerHTML;
		const optionsJson = JSON.parse(optionString);
		const nextButton = this.querySelector('.swiper-button-next');
		const prevButton = this.querySelector('.swiper-button-prev');
		const pagination = this.querySelector('.swiper-paginations');

		let options = {
			...optionsJson,
			navigation: {
				nextEl: nextButton,
				prevEl: prevButton,
			},
			pagination: {
				el: pagination,
				clickable: true,
			},
		};

		if (optionsJson.autoplay) {
			this.classList.add('swiper-autoplay');
			options.on = {
				...optionsJson.on,
				autoplayTimeLeft: (swiperInstance, timeLeft, percentage) => {
					this.style.setProperty('--swiper-autoplay-progress', 1 - percentage);
				},
			};
		}

		// Native HTML5 drag of linked slides (<a>, <img>) cancels pointer events mid-swipe
		swiper.addEventListener('dragstart', (event) => event.preventDefault());

		this._swiper = new Swiper(swiper, options);
	}

	disconnectedCallback() {
		this._swiper?.destroy();
	}
}

customElements.define('swiper-slider', SwiperSliderComponent);

/**
 * Quickview product
 */

class ProductQuickview extends HTMLElement {
	constructor() {
		super();
		this._onClick = this.showQuickview.bind(this);
		this._onKeyPress = this.keyPress.bind(this);
		this.addEventListener('click', this._onClick);
		this.addEventListener('keypress', this._onKeyPress);
	}

	disconnectedCallback() {
		this.removeEventListener('click', this._onClick);
		this.removeEventListener('keypress', this._onKeyPress);
	}

	keyPress(e) {
		if (e.key === 'Enter') {
			this.showQuickview();
		}
	}

	showQuickview() {
		var productUrl = this.getAttribute('data-product-url');
		const productId = this.getAttribute('data-product-id');
		const productTitle = this.getAttribute('data-product-title');
		const variantSelected = this.getAttribute('data-variant-id');
		const dataType = this.getAttribute('data-type');
		var dataTypeClass = '';

		const quickviewModal = document.querySelector('.quickview-modal');

		if (quickviewModal) {
			quickviewModal.remove();
		}

		if (dataType == 'options') {
			dataTypeClass = 'product-quickview-type__' + dataType;
		} else {
			dataTypeClass = 'product-quickview-type__quickview';
		}

		if (variantSelected) {
			productUrl = productUrl + `?variant=${variantSelected}`;
		}

		if (this.closest('cart-drawer')) {
			this.closest('cart-drawer').classList.remove('animate', 'active');
			document.body.classList.remove('overflow-hidden');
		}

		let modalHtml = '';
		modalHtml += '<modal-component id="product-modal_id-' + productId + '" class="quickview-modal ' + dataTypeClass + ' fade" data-position="right" role="dialog" aria-modal="true" data-modal-product-id="' + productId + '" tabindex="-1">';
		modalHtml += '<modal-dialog class="color-scheme-1 gradient" style="max-width: 500px">';
		modalHtml += '<modal-content>';

		modalHtml += '<modal-header>';
		modalHtml += '<div class="modal-title">';
		modalHtml += productTitle;
		modalHtml += '</div>';

		modalHtml += '<button class="close-modal" data-close="modal" tabindex="0">';
		modalHtml += '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" width="18" height="17" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path></svg>';
		modalHtml += '</button>';
		modalHtml += '</modal-header>';

		modalHtml += '<modal-body class="scroll-bar">';
		modalHtml += '<div class="modal-body_data-ajax modal-body_loading">';
		modalHtml += '<div class="loader-component"><span class="hidden">Loading...</span></div>';
		modalHtml += '</div>';
		modalHtml += '</modal-body>';

		modalHtml += '</modal-content>';
		modalHtml += '</modal-dialog>';
		modalHtml += '</modal-component>';

		if (document.getElementById('product-modal_id-' + productId)) {
			this.showModal('product-modal_id-' + productId);
		} else {
			//this.classList.add('loading');
			document.body.insertAdjacentHTML('afterbegin', modalHtml);
			document.getElementsByTagName('html')[0].classList.add('open-modal');

			setTimeout(function () {
				document.getElementById('product-modal_id-' + productId).classList.add('show');
			}, 200);

			fetch(productUrl)
				.then((response) => response.text())
				.then((responseText) => {
					const productModal = document.getElementById('product-modal_id-' + productId);
					const productContainer = productModal.querySelector('.modal-body_data-ajax');
					const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
					const productElement = responseHTML.querySelector('section[id^="MainProduct-"]');

					if (responseHTML.querySelector('variant-selects')) {
						const sectionId = responseHTML.querySelector('variant-selects').getAttribute('data-section');

						productContainer.innerHTML = productElement.innerHTML.replaceAll(sectionId, `product-quickview-${sectionId}`);

						// The cloned markup's element IDs were namespaced with `product-quickview-`
						// above. Keep data-section matching them (so ProductInfo updates the modal's
						// price/buttons/etc.) and point data-original-section at the real section
						// (so its fetch hits a section that actually exists on the server).
						productContainer.querySelectorAll('variant-selects, product-info').forEach((element) => {
							element.setAttribute('data-section', `product-quickview-${sectionId}`);
							element.setAttribute('data-original-section', sectionId);
							// Don't rewrite the page URL when switching variants inside the modal.
							element.setAttribute('data-update-url', 'false');
						});
					} else {
						productContainer.innerHTML = productElement.innerHTML;
					}

					if (window.Shopify && Shopify.PaymentButton) {
						Shopify.PaymentButton.init();
					}

					if (window.ProductModel) window.ProductModel.loadShopifyXR();
					this.preventVariantURLSwitching();

					productContainer.querySelectorAll('script').forEach((oldScriptTag) => {
						const newScriptTag = document.createElement('script');
						Array.from(oldScriptTag.attributes).forEach((attribute) => {
							newScriptTag.setAttribute(attribute.name, attribute.value);
						});
						newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
						oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
					});
				})
				.finally(() => {
					const productModal = document.getElementById('product-modal_id-' + productId);

					//this.classList.remove('loading');
					productModal.querySelector('.modal-body_data-ajax').classList.remove('modal-body_loading');
					productModal.classList.add('quickview-loaded');

					setTimeout(() => {
						productModal.focus();
					}, 50);
				});
		}
	}

	showModal(modalId) {
		document.getElementById(modalId).classList.add('show');
		document.getElementsByTagName('html')[0].classList.add('open-modal');
	}

	preventVariantURLSwitching() {
		const productId = this.getAttribute('data-product-id');
		const productModal = document.getElementById('product-modal_id-' + +productId);
		const variantPicker = productModal.querySelector('variant-selects');
		if (!variantPicker) return;

		variantPicker.setAttribute('data-update-url', 'false');
	}
}

customElements.define('product-quickview', ProductQuickview);

/**
 * Popup inner product variants
 */
class PopupVariantsInner extends HTMLElement {
	constructor() {
		super();
		this._onClick = this.showVariantsPopup.bind(this);
		this.addEventListener('click', this._onClick);
	}

	disconnectedCallback() {
		this.removeEventListener('click', this._onClick);
	}

	showVariantsPopup() {
		let productUrl = this.getAttribute('data-product-url');
		const productId = this.getAttribute('data-product-id');
		const productElement = this.closest('.product-card-wrapper');

		const variantModals = document.querySelectorAll('modal-variants');

		variantModals.forEach((modalItem) => {
			modalItem.remove();
		});

		if (productUrl.toLowerCase().includes('pr_prod_strat')) {
			const urlArray = productUrl.split('?pr_prod_strat');
			productUrl = urlArray[0] + '?section_id=popup-variants';
		}

		let modalHtml = '';
		modalHtml += '<modal-variants id="variants-modal_id-' + productId + '" class="variants-modal scroll-bar fade show" role="dialog" aria-modal="true" tabindex="0">';
		modalHtml += '<div class="variants-content ' + window.product_variant_scheme + '">';
		modalHtml += '<button class="close-modal-variant" data-close="modal-variant"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" width="18" height="17" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path></svg></button>';
		modalHtml += '<div class="variants-content-ajax">';
		modalHtml += '<div class="loading__spinner"> <svg class="spinner" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.0" viewBox="0 0 128 128" xml:space="preserve"><g><path d="M64 9.75A54.25 54.25 0 0 0 9.75 64H0a64 64 0 0 1 128 0h-9.75A54.25 54.25 0 0 0 64 9.75z" fill="currentColor"></path><animateTransform attributeName="transform" type="rotate" from="0 64 64" to="360 64 64" dur="800ms" repeatCount="indefinite"></animateTransform></g></svg></div>';
		modalHtml += '<div>';
		modalHtml += '<div>';
		modalHtml += '</modal-variants>';

		if (productElement.querySelector('modal-variants')) {
			this.closest('.product-card-wrapper').querySelector('modal-variants').classList.add('show');
		} else {
			this.classList.add('loading');
			const windowWith = window.innerWidth;

			if (windowWith <= 1024) {
				document.body.insertAdjacentHTML('beforeend', modalHtml);
			} else {
				this.closest('.product-card-wrapper').querySelector('.card__inner').insertAdjacentHTML('beforeend', modalHtml);
			}

			fetch(productUrl)
				.then((response) => response.text())
				.then((responseText) => {
					const modalElement = document.querySelector('modal-variants');
					const modalAjaxContent = modalElement.querySelector('.variants-content-ajax');

					modalAjaxContent.innerHTML = responseText;
				})
				.finally(() => {
					this.classList.remove('loading');

					setTimeout(() => {
						document.getElementById('variants-modal_id-' + productId).focus();
					}, 300);
				});
		}
	}
}

customElements.define('popup-variants', PopupVariantsInner);

/**
 * Popup inner product variants
 */
class PopupVariantsModal extends HTMLElement {
	constructor() {
		super();

		this._btnCloseModal = this.querySelector('[data-close="modal-variant"]');
		this._onClose = this.closeModalVariant.bind(this);
		this._onKeyDown = this.closeModalComponentEsc.bind(this);
		this._btnCloseModal.addEventListener('click', this._onClose);
		this.addEventListener('click', this.closeModalVariantComponent);
		this.addEventListener('keydown', this._onKeyDown);
	}

	disconnectedCallback() {
		this._btnCloseModal?.removeEventListener('click', this._onClose);
		this.removeEventListener('click', this.closeModalVariantComponent);
		this.removeEventListener('keydown', this._onKeyDown);
	}

	closeModalComponentEsc(e) {
		if (e.keyCode === 27) {
			this.closeModalVariant();
		}
	}

	closeModalVariant() {
		const currentModal = this.closest('modal-component');
		//const currentModalCart = this.closest('cart-drawer');

		this.remove();

		if (currentModal) {
			currentModal.focus();
		}

		setTimeout(() => {
			document.querySelector('cart-drawer').cartFocus();
		}, 300);

		// if (currentModalCart) {
		// 	currentModalCart.focus();
		// }
	}

	closeModalVariantComponent(e) {
		if (e.target !== this) {
			return;
		} else {
			const windowWith = window.innerWidth;

			if (windowWith <= 1024) {
				this.remove();
			}
		}
	}
}
customElements.define('modal-variants', PopupVariantsModal);
/**
 * Tab popup component
 */

class PopupTabs extends HTMLElement {
	constructor() {
		super();

		this._btnOpen = document.querySelectorAll('[data-tab-popup-target]');

		this._btnOpen.forEach((btnItem) => {
			btnItem.addEventListener('click', this.showModal);
		});
	}

	disconnectedCallback() {
		this._btnOpen?.forEach((btnItem) => {
			btnItem.removeEventListener('click', this.showModal);
		});
	}

	showModal(e) {
		e.preventDefault();

		const currentModalId = this.getAttribute('data-tab-popup-target');
		const currentModal = document.getElementById(currentModalId);
		const currentTabTrigger = this.getAttribute('data-item-tab-target');

		currentModal.querySelector('[data-tab-target="' + currentTabTrigger + '"]').click();

		document.getElementsByTagName('html')[0].classList.add('open-modal');
		currentModal.classList.add('show');
		this.scrollTop = 0;
	}
}

customElements.define('popup-tab', PopupTabs);

/**
 * Tabs component
 */
class TabItem extends HTMLElement {
	constructor() {
		super();
		this._onClick = this.displayTabContainer.bind(this);
		this._onKeyPress = this.keyPress.bind(this);
		this.addEventListener('click', this._onClick);
		this.addEventListener('keypress', this._onKeyPress);
	}

	disconnectedCallback() {
		this.removeEventListener('click', this._onClick);
		this.removeEventListener('keypress', this._onKeyPress);
	}

	keyPress(event) {
		if (event.key === 'Enter') {
			this.displayTabContainer(event);
		}
	}

	displayTabContainer(event) {
		event.preventDefault();

		const tabContainerTarget = this.getAttribute('data-tab-target');
		const tabAjaxUrl = this.getAttribute('data-ajax-url');

		if (tabAjaxUrl && !this.classList.contains('loaded')) {
			this.closest('tabs-component').classList.add('component-loading');
			this.classList.add('loading');

			if (this.classList.contains('active')) {
				return;
			} else {
				const ajaxDataElement = this.closest('tabs-component').querySelector('[data-ajax-content="' + tabContainerTarget + '"]');

				fetch(tabAjaxUrl)
					.then((response) => response.text())
					.then((responseText) => {
						const elementToGet = this.getAttribute('data-ajax-element');

						const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');

						if (elementToGet) {
							const tabContentHtml = responseHTML.querySelector(elementToGet);
							ajaxDataElement.innerHTML = tabContentHtml.innerHTML;
						} else {
							ajaxDataElement.innerHTML = responseText;
						}
					})
					.finally(() => {
						this.activeTabContainer();
						this.classList.add('loaded');
						this.classList.remove('loading');
						this.closest('tabs-component').classList.remove('component-loading');
					});
			}
		} else {
			if (this.classList.contains('active')) {
				return;
			} else {
				this.activeTabContainer();
			}
		}
	}

	activeTabContainer() {
		const currentTabContainer = this.closest('tabs-component');
		const tabContainerTarget = this.getAttribute('data-tab-target');

		currentTabContainer.querySelectorAll('tab-item').forEach((element) => {
			element.classList.remove('active');
		});

		this.classList.add('active');

		currentTabContainer.querySelectorAll('tab-data').forEach((element) => {
			element.classList.remove('active');
		});

		currentTabContainer.querySelector('[data-tab-container="' + tabContainerTarget + '"]').classList.add('active');
	}
}

customElements.define('tab-item', TabItem);

/**
 * Accordion component
 */
class AccordionHeader extends HTMLElement {
	constructor() {
		super();
		this._onClick = this.displayAccordionContainer.bind(this);
		this._onKeyPress = this.keyPress.bind(this);
		this.addEventListener('click', this._onClick);
		this.addEventListener('keypress', this._onKeyPress);
	}

	disconnectedCallback() {
		this.removeEventListener('click', this._onClick);
		this.removeEventListener('keypress', this._onKeyPress);
	}

	keyPress(e) {
		if (e.key === 'Enter') {
			this.displayAccordionContainer(e);
		}
	}

	displayAccordionContainer(event) {
		event.preventDefault();

		const currentAccordion = this.closest('accordion-component');
		const currentAccordionItem = this.closest('accordion-item');

		if (currentAccordion.getAttribute('data-type') == 'group') {
			if (currentAccordionItem.classList.contains('active')) {
				currentAccordionItem.classList.remove('active');
				return;
			} else {
				currentAccordion.querySelectorAll('accordion-item').forEach((element) => {
					element.classList.remove('active');
				});

				currentAccordionItem.classList.add('active');
				return;
			}
		} else {
			currentAccordionItem.classList.toggle('active');
		}
	}
}

customElements.define('accordion-title', AccordionHeader);

class ProductGallery extends HTMLElement {
	constructor() {
		super();

		const galleryContainer = this;
		const mainSwiper = this.querySelector('.gallery-main .swiper');
		const mainNext = this.querySelector('.gallery-main .swiper-button-next');
		const mainPrev = this.querySelector('.gallery-main .swiper-button-prev');
		const desktopColumn = parseInt(this.getAttribute('data-desktop-column'));
		const tabletColumn = parseInt(this.getAttribute('data-tablet-column'));
		const mobileColumn = parseInt(this.getAttribute('data-mobile-column'));

		const thumbSwiper = this.querySelector('.gallery-thumb .swiper');
		const thumbNext = this.querySelector('.gallery-thumb .swiper-button-next');
		const thumbPrev = this.querySelector('.gallery-thumb .swiper-button-prev');

		const layout = this.getAttribute('data-layout');

		// Fractional values (e.g. 1.25) show a peek of the next slide; single-media
		// products fall back to 1 so a lone image fills the container.
		const mainSlideCount = mainSwiper ? mainSwiper.querySelectorAll('.swiper-slide').length : 0;
		let cardsPerView = parseFloat(this.getAttribute('data-cards-per-view')) || 1;
		if (mainSlideCount <= 1) cardsPerView = 1;

		if (this.closest('modal-component')) {
			var swiperMain = this._swiperMain = new Swiper(mainSwiper, {
				spaceBetween: 10,
				slidesPerView: cardsPerView,
				autoHeight: false,
				allowTouchMove: true,
				navigation: {
					nextEl: mainNext,
					prevEl: mainPrev,
				},
				keyboard: {
					enabled: true,
				},
			});
		} else {
			// Layout 1 column
			if (layout == '1-column') {
				var swiperMain = this._swiperMain = new Swiper(mainSwiper, {
					spaceBetween: 20,
					autoHeight: false,
					allowTouchMove: true,
					navigation: {
						nextEl: mainNext,
						prevEl: mainPrev,
					},
					keyboard: {
						enabled: true,
					},
					breakpoints: {
						0: {
							slidesPerView: mobileColumn,
							slidesPerGroup: mobileColumn,
						},
						768: {
							slidesPerView: tabletColumn,
							slidesPerGroup: tabletColumn,
						},
						1280: {
							slidesPerView: desktopColumn,
							slidesPerGroup: desktopColumn,
						},
					},
				});
			} else {
				// Layout 2 columns
				// slidesPerView 'auto' so Swiper MEASURES each thumb instead of
				// computing a width from the column count. The column ladder (and the
				// optional max-height cap derived from it) lives in
				// component-product-gallery.css; with a numeric slidesPerView Swiper
				// wrote its own width inline and built the translate grid from that, so
				// any CSS that changed the painted size left the strip translating past
				// its own content. Measuring keeps geometry and paint on one number.
				// spaceBetween is 0 because the 10px gutter is a CSS margin on the
				// slide: Swiper's 'auto' measurement is an OUTER size, so it already
				// counts that margin - adding spaceBetween on top would advance the
				// translate grid 10px per slide further than the strip actually is.
				var swiperThumb = this._swiperThumb = new Swiper(thumbSwiper, {
					spaceBetween: 0,
					slidesPerView: 'auto',
					autoHeight: false,
					allowTouchMove: true,
					navigation: {
						nextEl: thumbNext,
						prevEl: thumbPrev,
					},
					keyboard: {
						enabled: true,
					},
				});

				var swiperMain = this._swiperMain = new Swiper(mainSwiper, {
					slidesPerView: cardsPerView,
					spaceBetween: 10,
					autoHeight: false,
					allowTouchMove: true,
					navigation: {
						nextEl: mainNext,
						prevEl: mainPrev,
					},
					keyboard: {
						enabled: true,
					},

					thumbs: {
						swiper: swiperThumb,
					},
				});
			}
		}

		swiperMain.on('transitionEnd', function () {
			window.pauseAllMedia();

			if (mainSwiper.querySelector('.swiper-slide-active')) {
				const slideMediaType = mainSwiper.querySelector('.swiper-slide-active').getAttribute('data-media-type');

				if (slideMediaType == 'video' || slideMediaType == 'model') {
					galleryContainer.classList.add('hidden-lightbox');
					swiperMain.allowTouchMove = false;
				} else {
					galleryContainer.classList.remove('hidden-lightbox');
					swiperMain.allowTouchMove = true;
				}
			}
		});

		// Sync the gallery to the selected variant's featured image on variant change
		// (Dawn ProductInfo publishes variantChange; this Mood Swiper gallery isn't a
		// Dawn media-gallery, so we slide it here).
		this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
			const mediaId = event?.data?.variant?.featured_media?.id;
			if (!mediaId || !this._swiperMain) return;
			const slides = [...mainSwiper.querySelectorAll('.swiper-slide')];
			const index = slides.findIndex((slide) => (slide.getAttribute('data-media-id') || '').endsWith(`-${mediaId}`));
			if (index >= 0) this._swiperMain.slideTo(index);
		});

		// Optimistic swap: slide to the newly selected variant's image the moment an
		// option is picked, without waiting for the section fetch that later fires
		// variantChange (which stays as the authoritative re-sync). Matches the
		// selection against the variants JSON embedded in variant-selects; option
		// order follows product.options_with_values, same as the picker markup.
		this.optionChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
			const target = event?.data?.target;
			const variantSelects = target?.closest?.('variant-selects');
			if (!variantSelects || !this._swiperMain) return;

			// Combined-listing pick pointing at another product: the current variants
			// JSON can't answer it; leave it to the fetch-driven swap.
			const productInfo = variantSelects.closest('product-info');
			if (target.dataset.productUrl && productInfo && target.dataset.productUrl !== productInfo.dataset.url) return;

			let variants;
			try {
				variants = JSON.parse(
					variantSelects.querySelector('script[type="application/json"]:not([data-selected-variant])')?.textContent
				);
			} catch {
				return;
			}
			if (!Array.isArray(variants)) return;

			// updateSelectionMetadata has already moved the selected attribute, so this
			// reflects the new selection (same selector as the selectedOptionValues getter).
			const selectedValues = Array.from(
				variantSelects.querySelectorAll('select option[selected], fieldset input:checked')
			).map((input) => input.value);
			const variant = variants.find(
				(candidate) =>
					candidate.options.length === selectedValues.length &&
					candidate.options.every((value, position) => value === selectedValues[position])
			);
			const mediaId = variant?.featured_media?.id;
			if (!mediaId) return;

			const slides = [...mainSwiper.querySelectorAll('.swiper-slide')];
			const index = slides.findIndex((slide) => (slide.getAttribute('data-media-id') || '').endsWith(`-${mediaId}`));
			if (index >= 0) this._swiperMain.slideTo(index);
		});
	}

	disconnectedCallback() {
		this._swiperMain?.destroy();
		this._swiperThumb?.destroy();
		this.variantChangeUnsubscriber?.();
		this.optionChangeUnsubscriber?.();
	}
}

customElements.define('product-gallery', ProductGallery);

/**
 * Galllery featured product
 */
class ProductGalleryFeatured extends HTMLElement {
	constructor() {
		super();

		const galleryContainer = this;
		const mainSwiper = this.querySelector('.gallery-main .swiper');
		const mainNext = this.querySelector('.gallery-main .swiper-button-next');
		const mainPrev = this.querySelector('.gallery-main .swiper-button-prev');

		var swiperMain = this._swiperMain = new Swiper(mainSwiper, {
			slidesPerView: 1,
			spaceBetween: 20,
			autoHeight: false,
			allowTouchMove: true,
			navigation: {
				nextEl: mainNext,
				prevEl: mainPrev,
			},
			keyboard: {
				enabled: true,
			},
		});

		swiperMain.on('transitionEnd', function () {
			window.pauseAllMedia();

			if (mainSwiper.querySelector('.swiper-slide-active')) {
				const slideMediaType = mainSwiper.querySelector('.swiper-slide-active').getAttribute('data-media-type');

				if (slideMediaType == 'video' || slideMediaType == 'model') {
					galleryContainer.classList.add('hidden-lightbox');
					swiperMain.allowTouchMove = false;
				} else {
					galleryContainer.classList.remove('hidden-lightbox');
					swiperMain.allowTouchMove = true;
				}
			}
		});
	}

	disconnectedCallback() {
		this._swiperMain?.destroy();
	}
}

customElements.define('product-gallery-featured', ProductGalleryFeatured);
/**
 * Gallery lightbox
 */

/**
 * Media badges in the product gallery and additional gallery lightboxes.
 *
 * Fancybox builds its own stage from the anchor's data-src, so a badge
 * rendered in the page (snippets/media-badge.liquid) never reaches it. Binding
 * these groups after Fancybox has self-bound '[data-fancybox]' makes this
 * opener win for their anchors (Fancybox picks the most recently registered
 * matching selector), and the badge is cloned onto the lightbox image once
 * the slide is ready. The main gallery renders its badge visibly on the slide
 * (found via the .ratio-content wrapper); the additional gallery keeps a
 * hidden badge inside each anchor purely for this hook, so the clone is
 * un-hidden. Same init guard as the welcome-video section: fancybox.umd.js is
 * deferred and only loaded on pages that need it.
 */
function bindGalleryMediaBadges() {
	if (typeof Fancybox === 'undefined') return false;

	Fancybox.bind('a[data-fancybox^="gallery-product-image"], a[data-fancybox^="additional-gallery"]', {
		on: {
			done: (fancybox, slide) => {
				const content = slide?.contentEl;
				const badge =
					slide?.triggerEl?.closest('.ratio-content')?.querySelector('.media-badge') ||
					slide?.triggerEl?.querySelector('.media-badge');

				if (!content || !badge || content.querySelector('.media-badge')) return;

				const clone = badge.cloneNode(true);
				clone.removeAttribute('hidden');
				content.appendChild(clone);
			},
		},
	});

	return true;
}

if (!bindGalleryMediaBadges()) {
	document.addEventListener('DOMContentLoaded', bindGalleryMediaBadges);
	window.addEventListener('load', bindGalleryMediaBadges);
}

/**
 * Video
 */

class PlayVideo extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', this.playVideo);
	}

	disconnectedCallback() {
		this.removeEventListener('click', this.playVideo);
	}

	playVideo() {
		const videoId = this.getAttribute('data-poster-id');

		setTimeout(() => {
			document.getElementById(videoId).click();
		}, 300);
	}
}

customElements.define('play-video', PlayVideo);

/**
 * Open sidebar menu
 */
class MobileMenuDrawer extends HTMLElement {
	constructor() {
		super();

		this.defaultColor = this.getAttribute('data-default-color');

		this._onKeyPress = this.keyPress.bind(this);
		this.addEventListener('click', this.openModal);
		this.addEventListener('keypress', this._onKeyPress);
	}

	disconnectedCallback() {
		this.removeEventListener('click', this.openModal);
		this.removeEventListener('keypress', this._onKeyPress);
	}

	keyPress(e) {
		if (e.key === 'Enter') {
			this.openModal(e);
		}
	}

	openModal(e) {
		e.preventDefault();

		const modalId = this.getAttribute('data-modal-target');
		const modalComponent = document.getElementById(modalId);

		//const btnOpenModal = this;

		if (this.classList.contains('active')) {
			this.classList.remove('active');
			this.setAttribute('aria-expanded', false);
			this.closest('.change-color-header').classList.remove(this.defaultColor);
			document.getElementsByTagName('html')[0].classList.remove('open-modal', 'header-menu-drawer');
			modalComponent.classList.remove('show');

			setTimeout(() => {
				modalComponent.focus();
			}, 300);

			return;
		} else {
			this.classList.add('active');
			this.setAttribute('aria-expanded', true);
			this.closest('.change-color-header').classList.add(this.defaultColor);
			document.getElementsByTagName('html')[0].classList.add('open-modal', 'header-menu-drawer');

			// Pin the drawer under the header where it actually is on screen, not
			// where it was at the top of the page.
			const headerBar = document.querySelector('.header-mobile .header-main-mobile');
			if (headerBar) {
				modalComponent.style.setProperty('--header-height', Math.max(0, headerBar.getBoundingClientRect().bottom) + 'px');
			}

			modalComponent.classList.add('show');

			setTimeout(() => {
				modalComponent.focus();
			}, 300);

			return;
		}
	}
}

if (!customElements.get('mobile-menu-drawer')) customElements.define('mobile-menu-drawer', MobileMenuDrawer);

/**
 * Custom page navigation
 */

if (!customElements.get('page-pagination')) {
	customElements.define(
		'page-pagination',
		class Pagination extends HTMLElement {
			constructor() {
				super();

				this._inputPage = this.querySelector('.change-page');

				if (this._inputPage) {
					this._inputPage.addEventListener('keypress', this.changePage);
				}
			}

			disconnectedCallback() {
				this._inputPage?.removeEventListener('keypress', this.changePage);
			}

			changePage(event) {
				if (event.key === 'Enter') {
					const currentUrlString = window.location.href;
					var currentUrl = new URL(currentUrlString);
					var search_params = currentUrl.searchParams;
					const pageValue = this.value;

					search_params.set('page', pageValue);
					currentUrl.search = search_params.toString();
					var newUrl = currentUrl.toString();
					window.location.href = newUrl;
				}
			}
		}
	);
}
